/**
 * MEMBER詳細
 */
import 'es6-promise/auto';
import 'picturefill';
import { breakpoint, containerID } from '@/_modules/utils/variables';
// vue
import Vue from 'vue';
import store from '@/_modules/stores';
import Loading from '@/_components/loading.vue';
import TransitionCover from '@/_components/transition-cover.vue';
import GlobalHeader from '@/_components/global-header.vue';
import GlobalFooter from '@/_components/global-footer.vue';
import GlobalNavi from '@/_components/global-navi.vue';
import Carousel from '@/_components/carousel.vue';
import CommonPlugin from '@/_modules/common/common-plugin';
Vue.use(CommonPlugin);

import scrollManager from '@/_modules/common/scrollManager';
import subBg from '@/_modules/common/subBg';
import hover from '@/_modules/common/hover';
window.$scrollManager = scrollManager;

export default class AppMemberEntry {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'AppMemberEntry';
    this.init();
  }

  /**
   * 初期
   */
  init() {
    new subBg();

    this.vue = new Vue({
      components: {
        Loading,
        TransitionCover,
        GlobalHeader,
        GlobalFooter,
        GlobalNavi,
        Carousel
      },
      data() {
        return {
          params: [],
          ispc: false,
          isLoaded: false,
          isState: '',
          isShowMore: false,
          urls: {},
          ticker: [],
        }
      },
      el: `#${containerID}`,
      store,
      computed: {
      },
      created() {
        this.$store.commit('setDevice');
      },
      mounted() {
        this.params = JSON.parse(document.getElementById('js-param-moreworks').textContent);
        this.urls = this.$store.getters.getUrls;

        $scrollManager.init();

        document.querySelectorAll('.c-worksList__hover').forEach((el, index) => {
          new hover(el, index);
        });

        this.$nextTick(this.start);
      },
      methods: {
        checkParent(terms) {
          return terms.filter(function (item) {
            return (item.parent === 0);
          })
        },
        start() {
          this.$store.commit('setShowCoverOut', false);
          if (this.$_checkShowMore()) {
            this.showMore();
          }
        },
        showLoading() {
          this.$store.commit('setShowLoading', true);
        },
        hideLoading() {
          this.$store.commit('setShowLoading', false);
        },
        showMore() {
          this.$_showMoreCookie();
          this.isShowMore = true;

          this.$nextTick(this.showMoreComp);
        },
        showMoreComp() {
          document.getElementById('c-worksList--more').querySelectorAll('.c-worksList__hover').forEach((el, index) => {
            new hover(el, index);
          });
        }
      }
    });
  }
}
